import { render, staticRenderFns } from "./ReviewHighlights.vue?vue&type=template&id=d0a55e08&scoped=true&"
import script from "./ReviewHighlights.vue?vue&type=script&lang=js&"
export * from "./ReviewHighlights.vue?vue&type=script&lang=js&"
import style0 from "./ReviewHighlights.vue?vue&type=style&index=0&id=d0a55e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a55e08",
  null
  
)

export default component.exports